import { motion } from "framer-motion";

export default function FounderStory() {
  return (
    <section
      id="founder"
      data-testid="founder-section"
      className="py-24 md:py-40 px-6 md:px-12 lg:px-20"
      style={{ background: "#F2EBE5" }}
    >
      <div className="max-w-[1200px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
          className="md:col-span-4"
        >
          <span className="overline" data-testid="founder-overline">The Story</span>
          <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl mt-6 leading-[1.05]">
            Why I built <em>Findaura</em>.
          </h2>
          <div className="gold-hair mt-8" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.4, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
          className="md:col-span-8"
        >
          <p className="font-serif italic text-3xl md:text-4xl lg:text-5xl leading-[1.15] text-[#1A1A1A]" data-testid="founder-pullquote">
            "AI should quiet the noise of your life — not add to it."
          </p>

          <div className="mt-12 max-w-2xl space-y-6 text-[15px] md:text-[17px] leading-relaxed text-[#1A1A1A]">
            <p>
              I didn't come from Silicon Valley. I came from real life — building, hustling, and figuring it
              out like every woman I know. When AI arrived, I saw it for what it truly was:{" "}
              <em className="font-serif italic text-[#C28C55]">the great equalizer.</em>{" "}
              For once, the door wasn't guarded. Anyone willing to learn could walk through it.
            </p>
            <p>
              So I did. I taught myself to use AI the way other women use a great assistant — to write, to plan,
              to automate the boring parts of business and life. And when I looked around, I noticed something:
              every course, every guru, every tutorial felt loud, technical, and made for someone else. Nothing spoke to{" "}
              <em className="font-serif italic">her</em> — the woman who wants ease, elegance, and elevation.
            </p>
            <p>
              So I built <em className="font-serif italic">Findaura Ventures</em> — an editorial-first AI education
              house for women. A soft-life sanctuary for the woman who wants technology to serve her aesthetic,
              her calendar, her craft, and her calm. I'm not teaching from a mountaintop; I'm building this in public,
              one automated and fabulous day at a time — and bringing you with me.
            </p>
          </div>

          {/* Enlarged editorial signature */}
          <div className="mt-16" data-testid="founder-signature">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-14 h-[1px] bg-[#C28C55]" />
              <span
                className="text-[10px] tracking-[0.35em] uppercase font-semibold"
                style={{ color: "#C28C55" }}
              >
                Signed
              </span>
            </div>
            <p className="font-serif italic font-light leading-none text-xl md:text-2xl lg:text-3xl text-[#1A1A1A]">
              January Bryant
            </p>
            <p
              className="mt-3 text-[10px] tracking-[0.3em] uppercase font-semibold"
              style={{ color: "#C28C55" }}
            >
              Founder, Findaura Ventures
            </p>
          </div>

          <div className="mt-12 flex items-center gap-4">
            <span className="overline">Est. 2026</span>
            <div className="w-8 h-[1px] bg-[#1A1A1A]/30" />
            <span className="overline">Findaura Ventures</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
